<!-- <h1 class="page-title">Transaction Receipts</h1> -->

<div class="table-wrapper">
  <table class="styled-table">
    <caption style="margin: 1rem 0;">
      Your transactions within the last 
      {{ monthsHistory === 12 ? '12 months' : '7 years' }}:
    </caption>
    <thead>
      <tr>
        <th style="width: 20%;">Purchase Date</th>
        <th style="width: 40%;">Product</th>
        <th style="width: 25%;">Total Amount</th>
        <th style="width: 15%;">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of purchaseHistory">
        <td>{{ item.serviceTransactionDate | amDateFormat: 'L' }}</td>
        <td>
          <div *ngFor="let desc of item.chargeDetail">
            {{ desc.codeDescription?.length ? 
                (desc.renewalYear ? desc.renewalYear + ' - ' + desc.codeDescription : desc.codeDescription)
                : 'Not Available' }}
          </div>
        </td>
        <td>${{ item.totalCost }}</td>
        <td>
          <a [routerLink]="['../../practitioner/purchase-detail', item.id]">
            View Receipt
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="toggle-link">
  <a href="javascript:void(0)" (click)="monthsHistory = monthsHistory === 12 ? 84 : 12; updateHistory();">
    {{ monthsHistory === 12 ? 'View more' : 'View fewer' }}
  </a>
</div>

<div *ngIf="ccpInfo" class="cmp-section">
  <h3>CMP Payments</h3>
  <ul class="cmp-list">
    <li *ngFor="let c of ccpInfo.cmpFees">
      {{ c.year }} - {{ c.reason }}
      <a *ngIf="c.serviceChargeId" 
         [routerLink]="['../../practitioner/purchase-detail', c.serviceChargeId]">
        View Receipt
      </a>
    </li>
  </ul>
</div>